export function ezcoinBalance(value) {
  const match = String(value ?? '').match(/^(\d+)(?:\.(\d{1,8}))?$/);
  if (!match) return '—';
  const fraction = (match[2] || '').padEnd(8, '0');
  const cents = BigInt(match[1]) * 100n + BigInt(fraction.slice(0, 2)) + (Number(fraction[2]) >= 5 ? 1n : 0n);
  return `${cents / 100n}.${String(cents % 100n).padStart(2, '0')}`;
}

export function ezcoinAmount(value) {
  const match = String(value ?? '').match(/^(\d+)(?:\.(\d{1,8}))?$/);
  if (!match) return '—';
  return `${BigInt(match[1])}.${(match[2] || '').replace(/0+$/, '').padEnd(2, '0')}`;
}
